import _ from 'lodash';
import { useEffect, useRef } from 'react';
import { RUN_TYPES } from 'v2/common/constants/index';
import { useSelector, useDispatch } from 'react-redux';
import { getSelectorBasedStoreValue } from 'v2/modules/withRunForm/redux/selector';
import { setRootValue } from 'v2/modules/withRunForm/redux/actions';
import HoverMessage from 'common/components/HoverMessage';
import { onChangeRunType } from '../../events/runType';
import ToggleGroupButton from 'v3/common/components/ToggleGroupButton';
import classNames from 'classnames';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
import { getUrlParams } from 'common/utils/urlUtils';

const RunType = () => {
  const dispatch = useDispatch();
  const isHistoricRunDisabled = useSelector((state) =>
    getSelectorBasedStoreValue(state, 'isHistoricRunDisabled')
  );
  const isLiveRunDisabled = useSelector((state) => getSelectorBasedStoreValue(state, 'isLiveRunDisabled'));
  const quantConfig = useSelector((state) => getSelectorBasedStoreValue(state, 'quantConfig'));

  const runType = useSelector((state) => getSelectorBasedStoreValue(state, 'runType'));
  const orderType = useSelector((state) => getSelectorBasedStoreValue(state, 'orderType'));
  const isStrategyAuthor = useSelector((state) => getSelectorBasedStoreValue(state, 'isStrategyAuthor'));
  const paramRunType = _.get(getUrlParams(), 'runtype');
  const { isAlgoverse } = ApplicationDomainUtility;
  const hideToggleRef = useRef( isAlgoverse && paramRunType === RUN_TYPES.live );

  const search = window.location.search;
  const isClonedOrEditQuant = search.includes('clone_from_run_id') || search.includes('edit_run_id');

  const onUpdateRunType = (newRunType) => {
    dispatch(
      setRootValue(onChangeRunType({ quantConfig, runType: newRunType, orderType, isStrategyAuthor }))
    );
  };

  const currentUserBroker = _.get(window, 'currentUserBroker', '');
  const isUserSignedIn = _.get(window, 'isUserSignedIn', false);
  const isEmailUser = _.get(window, 'isEmailUser', false);

  const isNonBrokerUser = isUserSignedIn && _.isEmpty(currentUserBroker);

  const disabledMessage = () => {
    if (isEmailUser) {
      return (
        'Live Run creations are not supported for email users. ' +
        'Please sign-in with broker account to create live runs.'
      );
    }
    if (isNonBrokerUser) {
      return (
        'Run creations are not supported for non-broker users. ' +
        'Please sign-in with broker account to create runs.'
      );
    }
    if (isHistoricRunDisabled && isLiveRunDisabled) {
      return 'Historic and live run creation is temporarily disabled';
    }
    if (isHistoricRunDisabled) return 'Historic run creation is temporarily disabled';
    if (isLiveRunDisabled) return 'Live run creation is temporarily disabled';

    return null;
  };

  const renderToggleBtn = () => {
    const toggleOptions = [
      {
        value: RUN_TYPES.historic,
        label: 'Backtest',
        disabled: isHistoricRunDisabled,
      },
      {
        value: RUN_TYPES.live,
        label: isAlgoverse ? 'Create' : _.startCase(RUN_TYPES.live),
        disabled: isLiveRunDisabled || isNonBrokerUser,
      },
    ];
    const className = classNames('run-type-btn', {
      'algoverse-run-type-btn': isAlgoverse,
      'visually-hidden': hideToggleRef.current,
    });
    return (
      <ToggleGroupButton
        className={className}
        options={toggleOptions}
        defaultValue={runType}
        value={runType}
        onChange={onUpdateRunType}
      />
    );
  };

  useEffect(() => {
    if (isAlgoverse && !isClonedOrEditQuant) {
      const nextRunType =  paramRunType === RUN_TYPES.live ? RUN_TYPES.live : RUN_TYPES.historic;
      if (nextRunType !== runType) onUpdateRunType(nextRunType);
    }
  }, []);

  return (
    <div className="run-type-header">
      {isHistoricRunDisabled || isLiveRunDisabled || isNonBrokerUser ? (
        <HoverMessage title="Run Type" message={disabledMessage()}>
          {renderToggleBtn()}
        </HoverMessage>
      ) : (
        renderToggleBtn()
      )}
    </div>
  );
};

export default RunType;
